import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsEmployeeDepartments from './SettingsEmployeeDepartments';

function DepartmentsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Departments"
        subtitle="Manage departments and teams"
        backTo="/settings/hr"
        backLabel="HR Management"
        sticky
      />
      <div className="p-6">
        <SettingsEmployeeDepartments />
      </div>
    </div>
  );
}

export default DepartmentsPage;
